module.exports = __webpack_public_path__ + "img/dfn_logo.bd61349c.png";